var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatisfaction3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 156",
    style: {
      enableBackground: "new 0 0 156 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;}\n\t.st1{font-family:'BerlinSansFBDemi-Bold';}\n\t.st2{font-size:50px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.8,1.1c5.8,0,10.5,4.7,10.5,10.5v132c0,5.8-4.7,10.5-10.5,10.5h-132c-5.8,0-10.5-4.7-10.5-10.5v-132 C1.3,5.8,6,1.1,11.8,1.1H143.8 M143.8-0.4h-132c-6.6,0-12,5.4-12,12v132c0,6.6,5.4,12,12,12h132c6.6,0,12-5.4,12-12v-132 C155.8,5,150.4-0.4,143.8-0.4L143.8-0.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M141.9,80.4h-20.3c-1.2,0-2.2,1-2.2,2.2v3.2h-5.6l-9.6-6.9c-2.2-1.5-4.7-2.5-7.3-2.7V21.2c0-3.2-2.6-5.8-5.8-5.8H17.7 c-3.2,0-5.8,2.6-5.8,5.8v113.7c0,3.2,2.6,5.8,5.8,5.8h65.6c-1.7-1-2.9-2.6-3.5-4.4H17.7c-0.8,0-1.4-0.6-1.4-1.4V21.2 c0-0.8,0.6-1.4,1.4-1.4h73.4c0.8,0,1.4,0.6,1.4,1.4v55.1H77.1c-0.1,0-0.2,0-0.3,0c-2.8,0.4-4.2,1.9-4.9,3c-0.9,1.4-1,3-1,4.3 c-1.9,0.7-3,1.8-3.6,2.8c-1.4,2.2-1.2,4.9-0.8,6.8c-1.2,0.7-2.1,1.6-2.8,2.8c-1.3,2.3-1.1,5-0.8,6.7c-4,2.8-5.4,6.8-3.9,11.3 c1,3,3.6,5.3,6.8,6l21.9,3.6c0,0.4,0,0.8-0.1,1.2c0.5,0,1,0.1,1.5,0.1c0.5-0.1,1.1-0.1,1.7-0.1c0.4,0,0.8,0,1.2,0.1 c0.1-1,0.1-2.1,0.1-3.1c0-1.1-0.8-1.9-1.8-2.1l-23.6-3.9c-1.6-0.4-3-1.5-3.5-3.1c-1-3,0-5.2,3.3-6.9c0.9-0.5,1.4-1.6,1.1-2.6 c-0.3-0.8-0.8-3.4,0.1-5c0.4-0.7,1.1-1.2,2.1-1.5c0.6-0.2,1.1-0.6,1.4-1.1c0.3-0.6,0.3-1.2,0.1-1.8c-0.3-0.7-1.1-3.5-0.1-5 c0.2-0.2,0.6-1,2.6-1.2c0.7-0.1,1.3-0.4,1.6-1c0.4-0.6,0.5-1.2,0.2-1.9c-0.1-0.4-0.5-2,0.1-3c0.1-0.2,0.4-0.7,1.6-0.9h18.4 c2.1,0,4.2,0.7,6,1.9l10.2,7.3c0.4,0.3,0.8,0.4,1.3,0.4l0,0h6.3v21.6h-5.5c-0.6,0-1.2,0.2-1.6,0.7l-11.6,12 c-0.3,0.3-0.5,0.7-0.6,1.2l-0.3,1.9c0,0,0,0,0,0c1,0,1.9,0.1,2.7,0.4c0.6-0.5,1.3-0.9,2.1-1.2l10.2-10.6h4.6v2 c0,1.2,1,2.2,2.2,2.2h20.3c1.2,0,2.2-1,2.2-2.2V82.6C144.1,81.4,143.1,80.4,141.9,80.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.4,123.1c-1.7,0.8-2.8,2.4-4.3,3.5c-1.4,1.1-3.1,1.8-4.8,2.3c-4.1,1.1-8.4,0.8-12.5,0.5c-1.8-0.1-3.6-0.3-5.2-1.1 c-0.2-0.1-0.5-0.2-0.7-0.4c-0.1-0.1-0.2-0.1-0.1,0c0,0.1,0,0.2,0,0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.9-0.5,1.6-0.8,2.6-1 c4.4-1.1,8.9-1.9,13.4-2.8c2.8-0.6,1.6-4.9-1.2-4.3c-4.3,0.9-8.5,1.7-12.8,2.7c-1.9,0.4-4,1.1-5.4,2.5 c-1.5,1.5-1.9,3.9-0.5,5.6c2.3,3,7.3,3.2,10.7,3.4c4.2,0.2,8.4,0.4,12.5-0.7c2-0.5,4-1.3,5.7-2.5c1.6-1.1,2.9-2.9,4.7-3.8 c1.1-0.5,1.4-2.1,0.8-3.1C104.8,122.8,103.5,122.6,102.4,123.1L102.4,123.1z"
  }))), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 79.1,
    y1: 138.4,
    x2: 96.6,
    y2: 137.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 94.6,
    y1: 131.9,
    x2: 94.6,
    y2: 139.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4,71.7h52c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2h-52c-1.2,0-2.2,1-2.2,2.2C26.2,70.7,27.2,71.7,28.4,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4,89.3h28.8c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2H28.4c-1.2,0-2.2,1-2.2,2.2C26.2,88.3,27.2,89.3,28.4,89.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4,106.9h22.9c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2H28.4c-1.2,0-2.2,1-2.2,2.2C26.2,105.9,27.2,106.9,28.4,106.9z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4,124.5h26c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2h-26c-1.2,0-2.2,1-2.2,2.2C26.2,123.5,27.2,124.5,28.4,124.5z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.85 0 0 1 40.528 60.7073)",
    className: "st1 st2"
  }, "C")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfaction3);
export default __webpack_public_path__ + "static/media/Satisfaction3.e019f595cc5c5c630015422f264a21c5.svg";
export { ForwardRef as ReactComponent };